// @ts-strict-ignore
import React, { ReactNode } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';

import { MainStoreState } from 'store/main';
import {
  hideModal as storeHideModal,
  showModal as storeShowModal,
} from 'store/main/ducks/modal';
import { deleteCookie, getCookieValue } from 'utils/cookies';

type OwnProps = {
  children: ReactNode;
};
type Props = OwnProps & RouteComponentProps & PropsFromRedux;

class UnconnectedShowUserModals extends React.PureComponent<Props> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/sort-comp
  verify() {
    const { currentUser, location, modal, showModal, hideModal } = this.props;
    const verifyEmail = !!currentUser.email && !currentUser.emailVerified;

    // Verify Email

    if (verifyEmail && !modal.type && location.pathname === '/survey/report') {
      return;
    }

    if (verifyEmail) {
      // INFORMATION_REQUIRED excepted for case of Facebook user not allowing
      // their email address and then has just filled one in.
      if (!modal.type || modal.type === 'INFORMATION_REQUIRED') {
        // only show the modal if another isn't already shown
        showModal('VERIFY_EMAIL');
      }

      return;
    }

    if (modal.type === 'VERIFY_EMAIL') {
      hideModal();
    }

    // OAuth

    if (getCookieValue('justSignedUpModal') && !modal.type) {
      const method = getCookieValue('justSignedUpModal');

      if (method === 'Google' || method === 'Facebook') {
        showModal('FINISH_OAUTH_SIGNUP', {
          onClose: () => deleteCookie('justSignedUpModal'),
        });
      } else {
        deleteCookie('justSignedUpModal');
      }

      return;
    }

    // Information Required

    const informationRequired =
      currentUser.id &&
      (!currentUser.firstName || !currentUser.lastName || !currentUser.email) &&
      location.pathname !== '/dashboard/account-settings';

    if (informationRequired) {
      if (!modal.type) {
        // only show the modal if another isn't already shown
        showModal('INFORMATION_REQUIRED');
      }

      return;
    }

    if (modal.type === 'INFORMATION_REQUIRED') {
      hideModal();
    }

    // iOS app needs log in
    const iOSAppNeedsLogIn =
      window.navigator.userAgent.includes('Idealist Mobile App') &&
      currentUser.isLoaded &&
      !currentUser.id;

    if (iOSAppNeedsLogIn) {
      if (!modal.type) {
        // only show the modal if another isn't already shown
        showModal('SIGNUP', { uncloseable: true });
      }

      return;
    }

    // Notification Preferences

    if (currentUser.showNotifPrefModal) {
      if (!modal.type) {
        // only show the modal if another isn't already shown
        showModal('NOTIFICATION_PREFERENCES');
      }

      return;
    }

    if (modal.type === 'NOTIFICATION_PREFERENCES') {
      hideModal();
    }
  }

  componentDidMount() {
    this.verify();
  }

  componentDidUpdate() {
    this.verify();
  }

  render() {
    const { children } = this.props;

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }
}

const mapStateToProps = ({ currentUser, modal }: MainStoreState) => ({
  currentUser,
  modal,
});

const connector = connect(mapStateToProps, {
  hideModal: storeHideModal,
  showModal: storeShowModal,
});

type PropsFromRedux = ConnectedProps<typeof connector>;

export const ShowUserModals = withRouter(connector(UnconnectedShowUserModals));
